export default __webpack_public_path__ + "9a2f043a86a0df70ff3234475e3abcf6.woff2";